import { AREA_CODES } from 'src/modules/forms/fields/AreaCodeTextField/components/AreaCodeSelect';

/**
 * Removes any country code prefixes from a phone number string
 * @param {string} phone - The phone number to process (e.g. "+52123456789", "52123456789", etc)
 * @returns {string} The phone number with any country code prefixes removed (e.g. "123456789")
 * @description
 * This function:
 * 1. Takes a phone number string that may contain a country code prefix
 * 2. Gets all possible country codes from the COUNTRY_CODES constant
 * 3. Iterates through each code and removes it from the phone number if found
 * 4. Returns the cleaned phone number without any country code prefixes
 * @example
 * // Returns "123456789"
 * removeCountryCodeFromPhone("+52123456789")
 * // Returns "123456789"
 * removeCountryCodeFromPhone("52123456789")
 */
export const removeCountryCodeFromPhone = (phone: string) => {
    let phoneWithoutCountryCode = phone

    const CodesToRemove = Object.values(AREA_CODES).map(
        (country) => country.code
    )

    CodesToRemove.forEach((code) => {
        phoneWithoutCountryCode = phoneWithoutCountryCode.replace(code, '')
    })

    return phoneWithoutCountryCode
}